import React from 'react'

const withInactive = (inactive?: boolean) => <T extends { inactive?: boolean }>(
    Component: React.ComponentType<T>
) => (props: T) => <Component {...props} inactive={inactive} />

export default withInactive
